<template>
  <div>
    <v-list-item-title class="mt-5 font-weight-medium text-center">{{ $t("LoggedArea.Links.PopUp.Icons.title") }}</v-list-item-title>
    <!-- Add normal icon -->
    <v-list-item-subtitle class="mt-5 font-weight-medium text-center">{{ $t("LoggedArea.Links.PopUp.Icons.subtitleanylink") }}</v-list-item-subtitle>
    <v-card
      v-for="(icon, index) in normalIcons"
      :key="-index-1"
      class="mx-auto mt-3"
      max-width="90%"
      outlinedopeninput
      @click="changeComponent(icon);eventAnalytics(icon.name)"
    >
      <v-list-item two-line >
        <v-list-item-avatar tile size="30" color="transparent" left>
          <v-img :src="icon.src"></v-img>
        </v-list-item-avatar>
        <v-list-item-content class="p-0" style="padding: 0px;">
          <v-list-item-title class="body-2 text-left">{{ icon.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-card>
    <!-- Request a new link type-->
    <a style="color: #4A148C;text-decoration-color: #4A148C;" 
    href="https://forms.gle/fA6ZeiCnUPShtfu7A" 
    target="_blank">
        <v-list-item-subtitle class="mt-3 ml-6 text-left">
            {{ $t("LoggedArea.Links.PopUp.Icons.linkrequest") }}
        </v-list-item-subtitle>
    </a>
    <!-- Add special icon-->
    <v-list-item-subtitle class="mt-5 font-weight-medium text-center">{{ $t("LoggedArea.Links.PopUp.Icons.subtitlespeciallink") }}</v-list-item-subtitle>
    <v-card
      v-for="(icon, index) in icons"
      :key="index"
      class="mx-auto mt-3"
      max-width="90%"
      outlinedopeninput
      @click="changeComponent(icon);eventAnalytics(icon.name)"
    >
      <v-list-item two-line>
        <v-list-item-avatar tile size="30" color="transparent" left>
          <v-img :src="icon.src"></v-img>
        </v-list-item-avatar>
        <v-list-item-content class="p-0" style="padding: 0px;">
          <v-list-item-title class="body-2 text-left">{{ icon.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </div>
</template>

<script>
import { analytics } from "@/config/firebaseConfig";
export default {
  props: ["icons","normalIcons"],
  computed:{
    coins(){
      return this.$store.state.coins
    }
  },
  methods:{
    changeComponent(icon){
      const component = icon.mgm === 0 || this.coins >= 2 ? 2 : 1
      this.$emit('component', component)
      this.$emit('set-src-icon', icon)
    },
    eventAnalytics(nameIcon){
      analytics.logEvent(`LinTp_${nameIcon}`)
    }
  }
};
</script>

<style>
</style>